import { cn } from "@/lib/utils";

export function SectionHeader({ eyebrow, title, description, align = "center", className }) {
  return (
    <div className={cn(
      "mb-12",
      align === "center" && "text-center",
      align === "left" && "text-left",
      className
    )}>
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground leading-tight mb-4">
        {title}
      </h2>
      {description && (
        <p className={cn(
          "text-base text-muted-foreground leading-relaxed",
          align === "center" && "max-w-2xl mx-auto"
        )}>
          {description}
        </p>
      )}
    </div>
  );
}

export function FeatureCard({ icon: Icon, title, description, className }) {
  return (
    <div className={cn(
      "group p-6 rounded-xl border border-border bg-card card-hover hover:border-primary/25",
      className
    )}>
      <div className="w-10 h-10 rounded-lg bg-primary/8 flex items-center justify-center mb-4 group-hover:bg-primary/14 transition-fast">
        <Icon className="w-5 h-5 text-primary" strokeWidth={1.75} />
      </div>
      <h3 className="text-sm font-display font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
}
